import { epicRequest, serverResponse } from 'app'

export const INSTITUTIONS_LIST_FETCH = 'INSTITUTIONS_LIST_FETCH'
export const INSTITUTIONS_LIST_FETCH_ERROR = 'INSTITUTIONS_LIST_FETCH_ERROR'
export const INSTITUTIONS_LIST_FETCH_FULFILLED = 'INSTITUTIONS_LIST_FETCH_FULFILLED'
export const INSTITUTIONS_LIST_FETCH_CANCELED = 'INSTITUTIONS_LIST_FETCH_CANCELED'

export const INSTITUTIONS_LIST_LIKE = 'INSTITUTIONS_LIST_LIKE'
export const INSTITUTIONS_LIST_LIKE_ERROR = 'INSTITUTIONS_LIST_LIKE_ERROR'
export const INSTITUTIONS_LIST_LIKE_FULFILLED = 'INSTITUTIONS_LIST_LIKE_FULFILLED'
export const INSTITUTIONS_LIST_LIKE_CANCELED = 'INSTITUTIONS_LIST_LIKE_CANCELED'

export const INITIAL_STATE = serverResponse()

export const institutionListFetch = (userId, page) => ({
  payload: { page, userId },
  type: INSTITUTIONS_LIST_FETCH,
})

export const institutionListFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTIONS_LIST_FETCH_FULFILLED,
})

export const institutionListFetchCanceled = () => ({
  payload: null,
  type: INSTITUTIONS_LIST_FETCH_CANCELED,
})

export const institutionListFetchError = (payload) => ({
  payload,
  type: INSTITUTIONS_LIST_FETCH_ERROR,
})

export const institutionListFetchEpic = epicRequest({
  actionType: INSTITUTIONS_LIST_FETCH,
  errorAction: institutionListFetchError,
  fulfilledAction: institutionListFetchFulfilled,
  request: ({ payload }) => `user/${payload.userId}/institutions?page=${payload.page}`,
  untilTypes: INSTITUTIONS_LIST_FETCH_CANCELED,
})

export const institutionListLike = (institutionId, like) => ({
  payload: { institutionId, like },
  type: INSTITUTIONS_LIST_LIKE,
})

export const institutionListLikeFulfilled = (payload) => ({
  payload,
  type: INSTITUTIONS_LIST_LIKE_FULFILLED,
})

export const institutionListLikeCanceled = () => ({
  payload: null,
  type: INSTITUTIONS_LIST_LIKE_CANCELED,
})

export const institutionListLikeError = (payload) => ({
  payload,
  type: INSTITUTIONS_LIST_LIKE_ERROR,
})

export const institutionListLikeEpic = epicRequest({
  actionType: INSTITUTIONS_LIST_LIKE,
  errorAction: institutionListLikeError,
  fulfilledAction: institutionListLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: `institution/${payload.institutionId}/${payload.like ? 'like' : 'unfollow'}`,
  }),
  untilTypes: INSTITUTIONS_LIST_LIKE_CANCELED,
})
